import update from 'immutability-helper';

export const composeRequiredValidator = (message) => (value) =>
  (
    value && // value should not be empty
    (typeof value !== 'string' || // also it should either be not string
      value.replace(/^\s*(.*?)\s*$/, '$1').length) // or not just spaces
  ) ?
    undefined
  : message;
export const composePhoneValidator = (message) => (value) => {
  if (value.length === 0) return undefined;
  return /[0-9]{10}$/.test(value) && value.charAt(0) === '9' && value.length === 10 ?
      undefined
    : message || '';
};
export const composeEmailValidator = (message) => (value) => {
  if (!value || value.length === 0) return undefined;
  return (
      /^([A-Za-z0-9_-]+\.)*[A-Za-z0-9_-]+@[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*\.[a-z]{2,6}$/.test(
        value,
      )
    ) ?
      undefined
    : message || '';
};

export const composeCheckedValidator = (message) => (value) => (!value ? message : undefined);

export const composeNameValidator = (message) => (value) => {
  if (value.length < 1) return message;
  if (value.replace(/ /g, '').length === 0) return message;

  return /^(?![- ])[A-Za-zёЁА-Яа-я -]{0,60}$/.test(value) ? undefined : message;
};
/**
 * given key: value object with errors,
 * concats all the errors into single object, separated by dot and space
 */
export const mergeErrorObject = (errors, ignoreFields = []) =>
  Object.keys(errors)
    .filter((key) => ignoreFields.indexOf(key) === -1)
    .map((key) => errors[key].replace(/\.$/, ''))
    .join('. ');

/** extracts .NET errors from response object, with properly attached field names */
export const convertBackendErrors = ({ Errors, View }) => {
  if (Errors && Object.keys(Errors).length) {
    /** Extract errors by converting UpperCamelCase keys to normal camelCase */
    return Object.keys(Errors).reduce(
      (errors, key) =>
        update(errors, {
          [key[0].toLowerCase() + key.slice(1)]: { $set: Errors[key].ErrorMessage },
        }),
      {},
    );
  } else if (View && View.IsSuccess === false) {
    /** Extract error crutched into response */
    return {
      _errors: `${View.Title}: ${View.Description}`,
    };
  }
  return null;
};
